import { Box, Grid, makeStyles, Typography } from '@material-ui/core';
import { GoogleOAuthProvider } from '@react-oauth/google';
import React, { useContext, useState } from 'react';
import { urlConfig } from '../../config/urlConfig';
import { ProfileContext } from '../../services/profile/profile.context';
import { ConnectAccountFacebook } from './connectAccountFacebook';
import { ConnectAccountGoogle } from './connectAccountGoogle';

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: '1rem',
  },
  formControl: {
    minWidth: '100%',
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  connectedAccount: {},
  connectedAccountContainer: {
    [theme.breakpoints.up(760)]: {
      display: 'flex',
    },
  },
  title: {
    fontWeight: 700,
  },
}));

const ConnectAccount = () => {
  const classes = useStyles();
  const [error, setError] = useState(false);

  return (
    <Grid item xs={12} className={classes.connectedAccount}>
      <Typography className={classes.title} gutterBottom>
        Connected Accounts
      </Typography>
      <Typography variant='body2'>
        Click on icon to activate signin with one of the following services
      </Typography>
      <Box
        mt={2}
        flexWrap='nowrap'
        className={classes.connectedAccountContainer}
      >
        <GoogleOAuthProvider clientId={urlConfig.GOOGLE_API}>
          <ConnectAccountGoogle setError={setError} />
        </GoogleOAuthProvider>

        {/* <ConnectAccountFacebook setError={setError} /> */}
        {/* <ConnectAccountTwitter userId={userId} /> */}
      </Box>
      <Typography color='error' variant='caption'>
        {error}
      </Typography>
    </Grid>
  );
};

export default ConnectAccount;
